import type { UI } from '@/v2/types';

import useSortedMainRoomOptions from '@shared/v2/hooks/useSortedMainRoomOptions';

import { useRoomOptionsData } from '../../../../contexts/RoomOptionsContext';
import RoomList from '../RoomList';

export type MainRoomsProps = {
  roomOptions: UI.RoomOption[] | undefined | null;
};

const MainRooms = ({ roomOptions }: MainRoomsProps) => {
  const { route, isPreSearch, isOriginSelected, isPackageSelected } =
    useRoomOptionsData() || {};

  const sortedRoomOptions = useSortedMainRoomOptions({
    roomOptions,
    isOriginAndPackageSelected: isOriginSelected && isPackageSelected,
    isPreSearch,
    route,
  });

  return sortedRoomOptions?.length ? (
    <RoomList
      data-testid="MAIN_ROOMS"
      roomOptions={sortedRoomOptions}
      isMainRooms
    />
  ) : null;
};

export default MainRooms;
